/**
 * Profile Summary Card Component
 * Displays user avatar, name, location, and skills
 * Matches Figma design from My Profile page
 */

import React from 'react';
import { MapPin } from 'lucide-react';
import { CandidateProfile } from '../../services/candidateServiceApi';

interface ProfileSummaryCardProps {
    profile: CandidateProfile;
    userName: string;
    userEmail: string;
}

const ProfileSummaryCard: React.FC<ProfileSummaryCardProps> = ({ profile, userName }) => {
    // Extract location from resume data - check both camelCase and snake_case
    const personalDetails = profile.parsedResume?.rawJson?.personal_details ||
                           profile.resume_data?.parsed_data?.personal_details;
    const city = personalDetails?.city || '';
    const state = personalDetails?.state || '';
    const country = personalDetails?.country || '';
    const location = [city, state, country].filter(Boolean).join(', ') || (profile.location ? profile.location : 'Location not specified');

    // Get skills - check all possible locations, limit to first 5 for display
    const allSkills = profile.parsedResume?.skills ||
                     profile.skills ||
                     profile.resume_data?.parsed_data?.skills?.skills ||
                     [];
    const skills = allSkills.slice(0, 5);

    // Get first name with capitalized first letter for avatar
    const firstName = profile.firstName || userName.split(' ')[0] || userName || 'U';
    const avatarLetter = firstName ? firstName.charAt(0).toUpperCase() : 'U';

    console.log('[ProfileSummaryCard] firstName:', firstName);
    console.log('[ProfileSummaryCard] avatarLetter:', avatarLetter);
    console.log('[ProfileSummaryCard] profile.firstName:', profile.firstName);
    console.log('[ProfileSummaryCard] userName:', userName);

    return (
        <div className="bg-white rounded-2xl p-6 border border-[#EDEDED] flex flex-col items-center relative overflow-hidden">
            {/* Avatar Section */}
            <div className="relative mb-4 mt-6">
                <div className="w-[120px] h-[120px] rounded-full bg-gradient-to-br from-[#015FA6] to-[#6EABFF] flex items-center justify-center shadow-sm">
                    <span className="text-white font-semibold text-5xl font-manrope leading-none">
                        {avatarLetter}
                    </span>
                </div>
            </div>

            <h3 className="text-2xl font-bold text-[#0B111E] mb-1 font-manrope tracking-tight">{userName || 'User Name'}</h3>
            <div className="flex items-center gap-1.5 text-[#A3AED0] text-sm font-medium mb-6">
                <MapPin size={14} />
                {location}
            </div>

            {/* Skills Grid */}
            <div className="flex flex-wrap justify-center gap-2 w-full">
                {skills.length > 0 ? (
                    skills.map((skill, index) => (
                        <span
                            key={index}
                            className="px-3 py-1.5 bg-[rgba(1,95,166,0.1)] text-[#015FA6] text-xs font-medium rounded-lg font-manrope"
                        >
                            {skill}
                        </span>
                    ))
                ) : (
                    <p className="text-sm text-gray-400">No skills listed</p>
                )}
            </div>
        </div>
    );
};

export default ProfileSummaryCard;
